import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './lib/ccl/template.css';
import './lib/ccl/elements.css';
import './lib/ccl/colors.css';
import './lib/ccl/ccl-icons.css';
import './lib/font-awesome/all.min.css';
import './scss/styles.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
